// L&TT home link route only
export const baseUrl = "https://atci.lkm.accenture.com/lttmicrosite-apis";

export const BASE_API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:1111"
    : window.location.href.includes("staging")
    ? "https://atcgn.lkm.staging.accenture.com/atcgnstaging-apis"
    : "https://atcgn.lkm.accenture.com/atcgn-api";

